import Cookies from 'js-cookie'

const cookieName = 'isSeznamUser'

const isUserFromSeznam = () => {
    var url = new URL(window.location.href)
    var utmSource = url.searchParams.get('utm_source')
    var utmMedium = url.searchParams.get('utm_medium')

    return (utmSource === 'www.seznam.cz' || utmMedium === 'sekce-z-internetu' || utmMedium === 'sbrowser' || utmMedium === 'z-boxiku')
}

const isSeznamUserByCookie = () => {
    return (Cookies.get(cookieName) === '1')
}

const isSeznamUser = () => {
    return (isUserFromSeznam() || isSeznamUserByCookie())
}

const init = () => {
    if (isUserFromSeznam()) {
        Cookies.set(cookieName, 1, {
            expires: 1 / 48 // 30 minutes
        })
    }

    if (isSeznamUser()) {
        document.body.classList.add('is-seznam-user')
    }
}

init()

export {isSeznamUser}